export enum SchemaType {
  CUSTOMER = 'customer',
  DISPATCH = 'dispatch',
  TICKET = 'ticket',
}
